export enum WdataEventResult {
    SUCCESS,
    FAILED
}
